import { Schema } from '@core/data/dto/schema';
import { TipSourceConfig } from './tip-source-config';

export const TipSourceSchema = {
    id: Schema.String,
    label: Schema.String,
    label_key: Schema.String,
    description: Schema.String,
    description_key: Schema.String,
    available: Schema.Boolean,
    configurable: Schema.Boolean,
    config: TipSourceConfig
};
